var $6076bf52518b8931$exports = {};
// js/register.js
// DOM Elements
const $6076bf52518b8931$var$registerForm = document.getElementById('register-form');
const $6076bf52518b8931$var$profileImageInput = document.getElementById('profile-image');
const $6076bf52518b8931$var$loadingSpinner = document.getElementById('loading-spinner');
const $6076bf52518b8931$var$errorMessageElement = document.getElementById('error-message');
// Event listener untuk form registrasi
$6076bf52518b8931$var$registerForm.addEventListener('submit', async function(e) {
    e.preventDefault(); // Mencegah form untuk submit secara default
    // Ambil nilai dari input form
    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;
    const confirmPassword = document.getElementById('confirm-password').value;
    // Validasi form
    if (!email || !password || !confirmPassword) return $6076bf52518b8931$var$displayErrorMessage('Harap isi semua kolom!');
    // Validasi email
    if (!$6076bf52518b8931$var$validateEmail(email)) return $6076bf52518b8931$var$displayErrorMessage('Email tidak valid!');
    // Validasi password
    if (password !== confirmPassword) return $6076bf52518b8931$var$displayErrorMessage('Password dan Konfirmasi Password tidak cocok!');
    if (password.length < 6) return $6076bf52518b8931$var$displayErrorMessage('Password harus memiliki minimal 6 karakter!');
    try {
        // Menampilkan loading spinner
        $6076bf52518b8931$var$loadingSpinner.style.display = 'block';
        // Mengirim data ke serverless function Netlify
        const response = await fetch('/.netlify/functions/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email,
                password: password
            })
        });
        const data = await response.json();
        if (response.status !== 200) throw new Error(data.message); // Jika ada error, lemparkan
        // Sembunyikan loading spinner setelah registrasi selesai
        $6076bf52518b8931$var$loadingSpinner.style.display = 'none';
        // Jika berhasil, redirect ke halaman home
        console.log("Registrasi berhasil! Menuju halaman utama.");
        window.location.href = '../html/home.html'; // Ganti dengan halaman home Anda
    } catch (error) {
        $6076bf52518b8931$var$loadingSpinner.style.display = 'none';
        console.error("Registrasi gagal:", error.message);
        $6076bf52518b8931$var$displayErrorMessage(`Gagal registrasi: ${error.message}`);
    }
});
// Fungsi untuk menampilkan pesan error
function $6076bf52518b8931$var$displayErrorMessage(message) {
    $6076bf52518b8931$var$errorMessageElement.innerText = message;
    $6076bf52518b8931$var$errorMessageElement.style.display = 'block';
}
// Fungsi validasi email
function $6076bf52518b8931$var$validateEmail(email) {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
}


//# sourceMappingURL=register.91acd1a8.js.map
